(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2560],{

/***/ 18544:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/games/[slug]",
      function () {
        return __webpack_require__(98015);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 68224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8920);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28889);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);




var Background = function(param) {
    var _zIndex = param.zIndex, zIndex = _zIndex === void 0 ? -3 : _zIndex, _fixed = param.fixed, fixed = _fixed === void 0 ? true : _fixed;
    var theme = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        zIndex: zIndex,
        position: fixed ? "fixed" : "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            position: "relative",
            width: "100%",
            height: "100%",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                priority: true,
                src: "/branding/img-background-gamenation".concat(theme.palette.type === "dark" ? "-dark" : "", ".svg"),
                alt: "game nation logo",
                layout: "fill",
                objectFit: "cover"
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Background);


/***/ }),

/***/ 95871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(282);
/* harmony import */ var _GradientTypography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80256);







var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    return {
        disabled: {
            "&& svg": {
                fill: "".concat(theme.palette.action.disabled, " !important")
            }
        }
    };
});
var GradientTextButton = function(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    var disabled = useStyles().disabled;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        color: "primary",
        variant: "text"
    }, rest), {
        classes: {
            disabled: disabled
        },
        children: rest.disabled ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: children
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_GradientTypography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            children: children
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (GradientTextButton);


/***/ }),

/***/ 44494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52663);
/* harmony import */ var components_common_PaperAction__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9087);




var ConfirmationDialog = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, primaryButton = param.primaryButton, secondaryButton = param.secondaryButton, title = param.title, description = param.description;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        open: isOpen,
        onClose: onClose,
        "aria-label": title,
        fullWidth: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_PaperAction__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            title: title,
            description: description,
            secondaryButton: secondaryButton,
            primaryButton: primaryButton
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ConfirmationDialog);


/***/ }),

/***/ 66610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28889);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);







var GameIcon = function(_param) /*#__PURE__*/ {
    var _size = _param.size, size = _size === void 0 ? 40 : _size, src = _param.src, _alt = _param.alt, alt = _alt === void 0 ? "Icon" : _alt, blurDataURL = _param.blurDataURL, _borderRadius = _param.borderRadius, borderRadius = _borderRadius === void 0 ? 12 : _borderRadius, _mr = _param.mr, mr = _mr === void 0 ? 2 : _mr, imagesAboveFold = _param.imagesAboveFold, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "size",
        "src",
        "alt",
        "blurDataURL",
        "borderRadius",
        "mr",
        "imagesAboveFold"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        borderRadius: borderRadius,
        mr: mr,
        overflow: "hidden",
        flexShrink: 0,
        width: size,
        height: size,
        position: "relative"
    }, rest), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            layout: "fill",
            src: src,
            objectFit: "cover",
            alt: alt,
            blurDataURL: blurDataURL,
            placeholder: blurDataURL ? "blur" : "empty",
            priority: imagesAboveFold
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (GameIcon);


/***/ }),

/***/ 80256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52543);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22318);

var GradientTypography = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    root: {
        background: "-webkit-linear-gradient(0, #D331FB 0%, #37BAFC 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        fontSize: "inherit",
        fontWeight: "inherit"
    }
})(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
/* harmony default export */ __webpack_exports__["Z"] = (GradientTypography);


/***/ }),

/***/ 9087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79895);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28889);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22318);



var PaperAction = function(param) {
    var title = param.title, description = param.description, secondaryButton = param.secondaryButton, primaryButton = param.primaryButton;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                p: 4,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        mb: 1,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            variant: "h6",
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        variant: "body2",
                        color: "textSecondary",
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                p: 2,
                pt: 0,
                display: "flex",
                justifyContent: "right",
                children: [
                    secondaryButton !== undefined && secondaryButton,
                    primaryButton
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PaperAction);


/***/ }),

/***/ 53618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28889);
/* harmony import */ var _material_ui_lab__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58365);




var FriendLoading = function(param) {
    var _height = param.height, height = _height === void 0 ? 40 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                variant: "circle",
                width: height,
                height: height
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                ml: 6,
                flex: 1,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    width: 200,
                    height: 16
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FriendLoading);


/***/ }),

/***/ 91941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35117);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8920);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50998);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28889);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96353);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67265);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(95757);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(16204);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(55517);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(44012);




var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        root: {
            padding: 0
        },
        chip: {
            minWidth: 45
        }
    });
});
var LeaderboardListItem = function(param) {
    var position = param.position, name = param.name, score = param.score, imageUrl = param.imageUrl, _isYou = param.isYou, isYou = _isYou === void 0 ? false : _isYou, _divider = param.divider, divider = _divider === void 0 ? false : _divider, _color = param.color, color = _color === void 0 ? "text.disabled" : _color, dividerColor = param.dividerColor;
    var classes = useStyles();
    var theme = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: classes.root,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            width: "100%",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flex: 1,
                    height: 56,
                    px: 4,
                    bgcolor: isYou ? theme.states.primary.outlinedHover : "transparent",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            display: "flex",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    color: isYou ? "text.primary" : color,
                                    textAlign: "right",
                                    width: 40,
                                    mr: 4,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        variant: "subtitle1",
                                        component: "span",
                                        children: String(position).padStart(2, "0")
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        alt: name,
                                        src: imageUrl,
                                        children: name.substr(0, 1)
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            variant: "body2",
                                            children: name
                                        }),
                                        isYou && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            variant: "body2",
                                            color: "textSecondary",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                id: "game.details.leaderboard.you.label"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        score >= 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            className: classes.chip,
                            label: score,
                            color: isYou ? "primary" : "default",
                            size: "small"
                        })
                    ]
                }),
                divider && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    mx: 4,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        light: true,
                        style: dividerColor ? {
                            backgroundColor: dividerColor
                        } : undefined
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LeaderboardListItem);


/***/ }),

/***/ 14357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports StyledButtton, PrimaryButton */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(28889);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_lab__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(58365);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22291);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(79450);
/* harmony import */ var hooks_mounted__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18063);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(44012);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29430);
/* harmony import */ var constants_events__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(19910);
/* harmony import */ var components_navigation_Link__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(18780);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 15px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  line-height: 16px;\n  height: 100%;\n  min-height: 42px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var ref = next_config__WEBPACK_IMPORTED_MODULE_3___default()(), config = ref.publicRuntimeConfig;
var StyledButtton = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_templateObject());
var PrimaryButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_templateObject1());
var NotLoggedInCta = function(_param) {
    var icon = _param.icon, title = _param.title, description = _param.description, _textAlign = _param.textAlign, textAlign = _textAlign === void 0 ? "left" : _textAlign, _titleVariant = _param.titleVariant, titleVariant = _titleVariant === void 0 ? "h4" : _titleVariant, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "icon",
        "title",
        "description",
        "textAlign",
        "titleVariant"
    ]);
    var isMounted = (0,hooks_mounted__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    var isLoggedIn = (0,hooks__WEBPACK_IMPORTED_MODULE_9__/* .useAuth */ .a)().isLoggedIn;
    var pathname = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().pathname;
    var send = (0,hooks__WEBPACK_IMPORTED_MODULE_10__/* .useAnalytics */ .z)().send;
    if (isLoggedIn) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
        textAlign: textAlign,
        width: "100%"
    }, rest), {
        children: [
            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                color: "grey.100",
                pb: 2,
                children: icon
            }),
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: !isMounted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    pb: 2,
                    height: 50,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_lab__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        variant: "text",
                        width: "60%",
                        height: 42
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    pb: 2,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                        variant: titleVariant,
                        component: "h1",
                        color: "textPrimary",
                        children: title
                    })
                })
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: !isMounted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    height: {
                        xs: 48,
                        md: 24
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_lab__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        variant: "text",
                        height: "inherit",
                        width: "100%"
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    variant: "body1",
                    color: "textSecondary",
                    children: description
                })
            }),
            !isMounted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                mt: 4,
                mb: 2,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_lab__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                    variant: "text",
                    width: "100%",
                    height: 42
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                mt: 4,
                mb: 2,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PrimaryButton, {
                    //@ts-ignore
                    component: components_navigation_Link__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .C,
                    href: config.DIGI_LOGIN_URL,
                    variant: "contained",
                    color: "primary",
                    fullWidth: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        id: "home.account.intro.login.button"
                    })
                })
            }),
            !isMounted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                display: "flex",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_lab__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                    width: "80%",
                    height: 42
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButtton, {
                //@ts-ignore
                component: components_navigation_Link__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .C,
                href: config.DIGI_REGISTER_URL,
                variant: "text",
                color: "primary",
                fullWidth: true,
                onClick: function() {
                    return send({
                        event: constants_events__WEBPACK_IMPORTED_MODULE_18__/* .Events.startRegistration */ .z.startRegistration,
                        data: {
                            channel: pathname
                        }
                    });
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    id: "home.account.intro.create_account.button"
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["ZP"] = (NotLoggedInCta);


/***/ }),

/***/ 94679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





var TabPanel = function(_param) {
    var children = _param.children, value = _param.value, index = _param.index, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children",
        "value",
        "index"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        role: "tabpanel",
        hidden: value !== index,
        id: "tabpanel-".concat(index),
        "aria-labelledby": "tab-".concat(index)
    }, rest), {
        children: value === index && children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (TabPanel);


/***/ }),

/***/ 51222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Games; },
/* harmony export */   "_": function() { return /* binding */ GAME_PROVIDER_SHORTCODES; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45362);





var ExternalGame = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 327).then(__webpack_require__.bind(__webpack_require__, 60487));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60487)
            ];
        }
    }
});
var Raffle = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9416), __webpack_require__.e(7554), __webpack_require__.e(8336)]).then(__webpack_require__.bind(__webpack_require__, 78336));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78336)
            ];
        }
    }
});
var ScratchAndWin = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9416), __webpack_require__.e(7554), __webpack_require__.e(9735), __webpack_require__.e(8317)]).then(__webpack_require__.bind(__webpack_require__, 28317));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28317)
            ];
        }
    }
});
var Trivia = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9416), __webpack_require__.e(5419), __webpack_require__.e(7935), __webpack_require__.e(4231), __webpack_require__.e(7554), __webpack_require__.e(302), __webpack_require__.e(6079)]).then(__webpack_require__.bind(__webpack_require__, 86079));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86079)
            ];
        }
    }
});
var Voting = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9416), __webpack_require__.e(7935), __webpack_require__.e(7554), __webpack_require__.e(8670)]).then(__webpack_require__.bind(__webpack_require__, 20935));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20935)
            ];
        }
    }
});
var SlotMachine = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9416), __webpack_require__.e(7554), __webpack_require__.e(3680), __webpack_require__.e(7971)]).then(__webpack_require__.bind(__webpack_require__, 27971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27971)
            ];
        }
    }
});
// TODO: enable when games are available
// const SpinTheWheel = dynamic(() => import('components/@game/InternalGame/SpinTheWheel'));
var Games = function(game) {
    switch(game.type){
        case services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .TypeOfGame.scratch */ .f2.scratch:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScratchAndWin, {
                game: game
            });
        case services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .TypeOfGame.quiz */ .f2.quiz:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Trivia, {
                id: game.id,
                slug: game.slugName
            });
        case services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .TypeOfGame.vote */ .f2.vote:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Voting, {
                id: game.id,
                slug: game.slugName
            });
        case services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .TypeOfGame.raffle */ .f2.raffle:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Raffle, {
                id: game.id,
                slug: game.slugName
            });
        case services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .TypeOfGame.slot */ .f2.slot:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SlotMachine, {
                id: game.id,
                slug: game.slugName
            });
        // case TypeOfGame.wheel:
        //   return <SpinTheWheel id={game.id} slug={game.slugName} />;
        case services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .TypeOfGame.webview */ .f2.webview:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ExternalGame, {
                game: game
            });
        default:
            return null;
    }
};
var _obj;
var GAME_PROVIDER_SHORTCODES = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .GameProvider.Newcom */ .Ui.Newcom, ""), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .GameProvider.Gameloft */ .Ui.Gameloft, "18764442404"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .GameProvider.Nazara */ .Ui.Nazara, "18764442484"), _obj);


/***/ }),

/***/ 28775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useBackRouter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68711);
/* harmony import */ var services_router_RouterProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63299);






var useBackRouter = function() {
    var fallbackRoute = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : routes__WEBPACK_IMPORTED_MODULE_2__/* .Routes.home */ .Z.home;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var prevRoute = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(services_router_RouterProvider__WEBPACK_IMPORTED_MODULE_3__/* .RouterContext */ ._);
    var back = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function() {
        if (prevRoute) {
            router.back();
        } else {
            router.replace(fallbackRoute);
        }
    }, [
        fallbackRoute,
        prevRoute,
        router
    ]);
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, router), {
        back: back
    });
};


/***/ }),

/***/ 98015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(28889);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./src/hooks/useBackRouter.ts
var useBackRouter = __webpack_require__(28775);
// EXTERNAL MODULE: ./src/hooks/useAnalytics.ts
var useAnalytics = __webpack_require__(79450);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/queries/games/detail/useGetGameDetails.ts
var useGetGameDetails = __webpack_require__(96420);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/hooks/auth/util.tsx
var util = __webpack_require__(15776);
// EXTERNAL MODULE: ./node_modules/lodash/uniq.js
var uniq = __webpack_require__(44908);
var uniq_default = /*#__PURE__*/__webpack_require__.n(uniq);
// EXTERNAL MODULE: ./node_modules/notistack/dist/notistack.esm.js + 1 modules
var notistack_esm = __webpack_require__(8972);
// EXTERNAL MODULE: ./src/queries/QueryKeys.ts
var QueryKeys = __webpack_require__(11777);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(1844);
// EXTERNAL MODULE: ./src/services/api/ApiService.ts + 19 modules
var ApiService = __webpack_require__(58416);
;// CONCATENATED MODULE: ./src/queries/favorites/useFavorite.ts















var useFavorite = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var intl = (0,useIntl/* default */.Z)();
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var queryClient = (0,es.useQueryClient)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,recoil.useRecoilState)(util/* authState */.fD), 2), auth = ref[0], setAuth = ref[1];
    var ref1 = (0,es.useMutation)(function(param) {
        var id = param.id;
        return ApiService/* default.addFavoriteGame */.Z.addFavoriteGame(id);
    }, (0,_object_spread/* default */.Z)({
        onMutate: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var id, previousAccount;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            id = param.id;
                            return [
                                4,
                                queryClient.cancelQueries(QueryKeys/* QueryKeys.account.all */.i.account.all())
                            ];
                        case 1:
                            _state.sent();
                            previousAccount = queryClient.getQueryData(QueryKeys/* QueryKeys.account.all */.i.account.all());
                            // Optimistically update to the new value
                            queryClient.setQueryData(QueryKeys/* QueryKeys.account.all */.i.account.all(), function(old) {
                                if (!old) {
                                    return;
                                }
                                var ref;
                                var newAccount = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, old), {
                                    favorites: uniq_default()((0,_to_consumable_array/* default */.Z)((ref = old === null || old === void 0 ? void 0 : old.favorites) !== null && ref !== void 0 ? ref : []).concat([
                                        id
                                    ]))
                                });
                                setAuth((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, auth), {
                                    user: newAccount
                                }));
                                return newAccount;
                            });
                            // Return a context object with the snapshotted value
                            return [
                                2,
                                {
                                    previousAccount: previousAccount
                                }
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        // If the mutation fails, use the context returned from onMutate to roll back
        onError: function(error, _id, context) {
            var ref;
            // If error is a 409 we handle it as a success. Because api state is correct and the game should be favorited already
            if (((ref = error.response) === null || ref === void 0 ? void 0 : ref.status) === 409) {
                return;
            }
            if (context === null || context === void 0 ? void 0 : context.previousAccount) {
                queryClient.setQueryData(QueryKeys/* QueryKeys.account.all */.i.account.all(), context.previousAccount);
                setAuth((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, auth), {
                    user: context.previousAccount
                }));
            }
            enqueueSnackbar(intl.formatMessage({
                id: "games.error.favorite"
            }), {
                variant: "error"
            });
        },
        onSettled: function() {
            queryClient.invalidateQueries(QueryKeys/* QueryKeys.account.all */.i.account.all());
        }
    }, options)), favoriteGame = ref1.mutate;
    var ref2 = (0,es.useMutation)(function(param) {
        var id = param.id;
        return ApiService/* default.deleteFavoriteGame */.Z.deleteFavoriteGame(id);
    }, (0,_object_spread/* default */.Z)({
        onMutate: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var id, previousAccount;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            id = param.id;
                            return [
                                4,
                                queryClient.cancelQueries(QueryKeys/* QueryKeys.account.all */.i.account.all())
                            ];
                        case 1:
                            _state.sent();
                            previousAccount = queryClient.getQueryData(QueryKeys/* QueryKeys.account.all */.i.account.all());
                            // Optimistically update to the new value
                            queryClient.setQueryData(QueryKeys/* QueryKeys.account.all */.i.account.all(), function(old) {
                                if (!old) {
                                    return;
                                }
                                var ref;
                                var newAccount = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, old), {
                                    favorites: ((ref = old === null || old === void 0 ? void 0 : old.favorites) !== null && ref !== void 0 ? ref : []).filter(function(i) {
                                        return i !== id;
                                    })
                                });
                                setAuth((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, auth), {
                                    user: newAccount
                                }));
                                return newAccount;
                            });
                            // Return a context object with the snapshotted value
                            return [
                                2,
                                {
                                    previousAccount: previousAccount
                                }
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        // If the mutation fails, use the context returned from onMutate to roll back
        onError: function(error, _id, context) {
            var ref;
            // If error is a 404 this means the favorite is not found, so the api was already correct
            if (((ref = error.response) === null || ref === void 0 ? void 0 : ref.status) === 404) {
                return;
            }
            if (context === null || context === void 0 ? void 0 : context.previousAccount) {
                queryClient.setQueryData(QueryKeys/* QueryKeys.account.all */.i.account.all(), context.previousAccount);
                setAuth((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, auth), {
                    user: context.previousAccount
                }));
            }
            enqueueSnackbar(intl.formatMessage({
                id: "games.error.unfavorite"
            }), {
                variant: "error"
            });
        },
        onSettled: function() {
            queryClient.invalidateQueries(QueryKeys/* QueryKeys.account.all */.i.account.all());
        }
    }, options)), unFavoriteGame = ref2.mutate;
    var isFavoritedGame = (0,react.useCallback)(function(gameId) {
        var account = auth.user;
        var ref;
        return ((ref = account === null || account === void 0 ? void 0 : account.favorites) !== null && ref !== void 0 ? ref : []).includes(gameId);
    }, [
        auth.user
    ]);
    return {
        favoriteGame: favoriteGame,
        unFavoriteGame: unFavoriteGame,
        isFavoritedGame: isFavoritedGame
    };
};

// EXTERNAL MODULE: ./src/routes.ts
var routes = __webpack_require__(68711);
// EXTERNAL MODULE: ./src/utils/routes.utils.ts
var routes_utils = __webpack_require__(24039);
// EXTERNAL MODULE: ./src/constants/events.ts
var events = __webpack_require__(19910);
// EXTERNAL MODULE: ./src/services/api/definitions/game.definitions.ts
var game_definitions = __webpack_require__(45362);
// EXTERNAL MODULE: ./src/components/@common/Background/Background.tsx
var Background = __webpack_require__(68224);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/AppBar/AppBar.js
var AppBar = __webpack_require__(45258);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Toolbar/Toolbar.js
var Toolbar = __webpack_require__(28358);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ArrowBack.js
var ArrowBack = __webpack_require__(69826);
// EXTERNAL MODULE: ./src/components/@common/GameIcon/GameIcon.tsx
var GameIcon = __webpack_require__(66610);
;// CONCATENATED MODULE: ./src/components/@game-detail/DetailsNavigationBar/DetailsNavigationBar.tsx





var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        action: {
            fontSize: 13,
            fontWeight: "bold",
            padding: 4,
            height: 30
        },
        payText: {
            fontSize: 10,
            lineHeight: 1.2,
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
            flexShrink: 1
        },
        title: {
            lineHeight: 1
        },
        caption: {
            paddingTop: 2,
            lineHeight: 1
        }
    };
});
var DetailsNavigationBar = function(param) {
    var iconUrl = param.iconUrl, title = param.title, category = param.category, onBackClick = param.onBackClick;
    var classes = useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBar/* default */.Z, {
        color: "default",
        elevation: 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toolbar/* default */.Z, {
            variant: "dense",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    color: "primary.text",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        edge: "start",
                        "aria-label": "back",
                        color: "inherit",
                        onClick: onBackClick,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {})
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    ml: 2,
                    display: "flex",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GameIcon/* default */.Z, {
                            src: iconUrl,
                            size: 32,
                            alt: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: classes.title,
                                    variant: "caption",
                                    color: "textPrimary",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: title
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: classes.caption,
                                    variant: "caption",
                                    color: "textSecondary",
                                    children: category
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var DetailsNavigationBar_DetailsNavigationBar = (DetailsNavigationBar);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tabs/Tabs.js + 7 modules
var Tabs = __webpack_require__(57821);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tab/Tab.js
var Tab = __webpack_require__(41423);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Skeleton/Skeleton.js
var Skeleton = __webpack_require__(58365);
// EXTERNAL MODULE: ./src/hooks/mounted/useMounted.ts
var useMounted = __webpack_require__(18063);
// EXTERNAL MODULE: ./src/hooks/auth/useAuth.ts
var useAuth = __webpack_require__(22291);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/queries/subscriptions/useSubscriptions.ts
var useSubscriptions = __webpack_require__(58147);
;// CONCATENATED MODULE: ./src/queries/games/useFriendsPlaying.ts






var useFriendsPlaying = function(id) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        enabled: true
    };
    var isLoggedIn = (0,useAuth/* useAuth */.a)().isLoggedIn;
    var ref = (0,es.useQuery)(QueryKeys/* QueryKeys.allgames.friendsplaying */.i.allgames.friendsplaying(id), function() {
        return ApiService/* default.getFriendsPlaying */.Z.getFriendsPlaying(id);
    }, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
        enabled: isLoggedIn && options.enabled
    })), data = ref.data, isLoading = ref.isLoading;
    return {
        isLoading: isLoading,
        friends: data !== null && data !== void 0 ? data : []
    };
};

// EXTERNAL MODULE: ./src/queries/collections/useJumpBackIn.ts
var useJumpBackIn = __webpack_require__(85177);
// EXTERNAL MODULE: ./src/queries/collections/useCollectionById.ts
var useCollectionById = __webpack_require__(49874);
// EXTERNAL MODULE: ./src/queries/games/useExternalGameUrl.ts
var useExternalGameUrl = __webpack_require__(76829);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./node_modules/react-swipeable-views/lib/index.js
var lib = __webpack_require__(77314);
// EXTERNAL MODULE: ./src/utils/game.utils.ts
var game_utils = __webpack_require__(62698);
;// CONCATENATED MODULE: ./src/utils/gameDetails/game.utils.ts
var mapGameDetails = function(game) {
    return {
        title: game.name,
        description: game.description,
        // Structure is [{ "provider": "NewCom" }, { "age": "16+" }]
        specifications: game.metadata.filter(function(m) {
            return !!Object.entries(m).length;
        }).map(function(m) {
            var data = Object.entries(m)[0];
            return {
                id: data[0],
                label: data[0],
                value: data[1]
            };
        }),
        images: game.exampleImages.map(function(image, idx) {
            return {
                src: image,
                alt: "".concat(game.name, " example image ").concat(idx)
            };
        })
    };
};

// EXTERNAL MODULE: ./src/components/@friends/FriendLoading/FriendLoading.tsx
var FriendLoading = __webpack_require__(53618);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Collapse/Collapse.js
var Collapse = __webpack_require__(66037);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ArrowDownward.js
var ArrowDownward = __webpack_require__(21673);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ArrowUpward.js
var ArrowUpward = __webpack_require__(29594);
;// CONCATENATED MODULE: ./src/components/@game-detail/About/AboutGame/AboutGame.tsx







var Specifications = dynamic_default()(__webpack_require__.e(/* import() */ 7396).then(__webpack_require__.bind(__webpack_require__, 57396)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57396)
            ];
        }
    }
});
var Images = dynamic_default()(__webpack_require__.e(/* import() */ 9729).then(__webpack_require__.bind(__webpack_require__, 77286)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(77286)
            ];
        }
    }
});
var AboutGame_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        collapse: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(3)
        }
    };
});
var AboutGame = function(param) {
    var title = param.title, description = param.description, specifications = param.specifications, images = param.images;
    var classes = AboutGame_useStyles();
    var ref = (0,react.useState)(false), isOpen = ref[0], setOpen = ref[1];
    var handleReadMoreClick = function() {
        setOpen(!isOpen);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body1",
                color: "textPrimary",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                className: classes.collapse,
                in: isOpen,
                collapsedSize: 60,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    color: "textSecondary",
                    children: description
                })
            }),
            description && description.length > 130 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                display: "flex",
                mb: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "text",
                    color: "primary",
                    onClick: handleReadMoreClick,
                    endIcon: isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUpward/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDownward/* default */.Z, {}),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: isOpen ? "general.actions.read_less" : "general.actions.read_more"
                    })
                })
            }),
            images.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Images, {
                items: images
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mt: !!images.length ? 10 : 0,
                children: specifications.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Specifications, {
                    items: specifications
                })
            })
        ]
    });
};
/* harmony default export */ var AboutGame_AboutGame = (AboutGame);

;// CONCATENATED MODULE: ./src/components/@game-detail/About/About.tsx







var GameSection = dynamic_default()(__webpack_require__.e(/* import() */ 9390).then(__webpack_require__.bind(__webpack_require__, 49390)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49390)
            ];
        }
    }
});
var About_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        title: {
            marginBottom: theme.spacing(4),
            marginTop: theme.spacing(10)
        }
    };
});
var About = function(param) {
    var recommendedGames = param.recommendedGames, details = param.details, _showTitle = param.showTitle, showTitle = _showTitle === void 0 ? false : _showTitle;
    var classes = About_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        mx: 4,
        display: "flex",
        flexDirection: "column",
        children: [
            showTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: classes.title,
                variant: "h5",
                component: "h2",
                color: "textPrimary",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "game.details.tabs.about"
                })
            }),
            details && /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutGame_AboutGame, (0,_object_spread/* default */.Z)({}, details)),
            !!(recommendedGames === null || recommendedGames === void 0 ? void 0 : recommendedGames.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: classes.title,
                        variant: "h5",
                        component: "h2",
                        color: "textPrimary",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "game.you_may_also_like.title"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GameSection, {
                        id: "recommended_games",
                        variant: "detail",
                        data: recommendedGames,
                        disablePadding: true
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var About_About = (About);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(29430);
;// CONCATENATED MODULE: ./src/utils/gameDetails/getFriendNames.ts
var getFriendNames = function(friends) {
    if (friends.length === 1) {
        return {
            id: "game.details.friends_playing.one",
            values: {
                name1: friends[0].username
            }
        };
    }
    if (friends.length === 2) {
        return {
            id: "game.details.friends_playing.two",
            values: {
                name1: friends[0].username,
                name2: friends[1].username
            }
        };
    }
    if (friends.length === 3) {
        return {
            id: "game.details.friends_playing.three",
            values: {
                name1: friends[0].username,
                name2: friends[1].username,
                name3: friends[2].username
            }
        };
    }
    if (friends.length === 4) {
        return {
            id: "game.details.friends_playing.four",
            values: {
                name1: friends[0].username,
                name2: friends[1].username,
                name3: friends[2].username,
                name4: friends[3].username
            }
        };
    }
    return {
        id: "game.details.friends_playing.many",
        values: {
            name1: friends[0].username,
            name2: friends[1].username,
            name3: friends[2].username,
            count: friends.length - 3
        }
    };
};

// EXTERNAL MODULE: ./src/components/@common/Share/util.tsx
var Share_util = __webpack_require__(11936);
// EXTERNAL MODULE: ./src/constants/blurBase64.ts
var blurBase64 = __webpack_require__(56278);
;// CONCATENATED MODULE: ./src/components/@game-detail/Friends/components/ImageGroup/ImageGroup.tsx





var ImageGroup = function(param) {
    var images = param.images;
    if (!images) {
        return null;
    }
    var hasMore = images.length > 4;
    var showcasedImages = hasMore ? [
        images[0],
        images[1],
        images[2]
    ] : images;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        position: "relative",
        children: [
            showcasedImages.map(function(image, key) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    borderColor: "white",
                    border: "2px solid",
                    display: "inline-flex",
                    borderRadius: "50%",
                    zIndex: 4 - key,
                    ml: key > 0 ? -2 : 0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GameIcon/* default */.Z, {
                        size: 32,
                        src: image.url,
                        alt: image.alt,
                        mr: 0,
                        borderRadius: "50%",
                        imagesAboveFold: true,
                        blurDataURL: blurBase64/* default */.Z
                    })
                }, key);
            }),
            hasMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                borderColor: "white",
                border: "2px solid",
                display: "inline-flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50%",
                width: "36px",
                height: "36px",
                bgcolor: "grey.400",
                ml: -2,
                color: "white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    children: "+".concat(images.length - 3)
                })
            })
        ]
    });
};
/* harmony default export */ var ImageGroup_ImageGroup = (ImageGroup);

;// CONCATENATED MODULE: ./src/components/@game-detail/Friends/Friends.tsx





function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: underline;\n  &:hover {\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var ref = config_default()(), Friends_config = ref.publicRuntimeConfig;
var StyledTypography = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z)(_templateObject());
var Friends = function(param) {
    var friends = param.friends, avatar = param.avatar, shareTitle = param.shareTitle;
    var theme = (0,useTheme/* default */.Z)();
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var intl = (0,useIntl/* default */.Z)();
    var asPath = (0,next_router.useRouter)().asPath;
    var handleShareClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var url;
            return (0,tslib_es6.__generator)(this, function(_state) {
                url = Friends_config.CLIENT_URL + asPath;
                if ((0,Share_util/* canShare */.WK)()) {
                    (0,Share_util/* handleOnShare */.Wt)({
                        title: intl.formatMessage({
                            id: "seo.title_template"
                        }),
                        url: url,
                        text: intl.formatMessage({
                            id: "game.details.friends_playing.share.text"
                        }, {
                            title: shareTitle
                        })
                    });
                } else if (!(0,Share_util/* canShare */.WK)() && (0,Share_util/* canCopy */.hJ)()) {
                    (0,Share_util/* handleCopyLink */.cf)(url);
                    enqueueSnackbar(intl.formatMessage({
                        id: "friends.page.copy_link.message"
                    }));
                }
                return [
                    2
                ];
            });
        });
        return function handleShareClick() {
            return _ref.apply(this, arguments);
        };
    }();
    if (!friends.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            display: "flex",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GameIcon/* default */.Z, {
                    src: avatar,
                    borderRadius: "50%",
                    size: 32,
                    mr: 4,
                    imagesAboveFold: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    color: "text.secondary",
                    clone: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "caption",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "game.details.friends_playing.zero",
                            values: {
                                b: function(v) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        fontWeight: "bold",
                                        color: "text.primary",
                                        onClick: handleShareClick,
                                        clone: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTypography, {
                                            variant: "caption",
                                            color: "secondary",
                                            children: v
                                        })
                                    });
                                }
                            }
                        })
                    })
                })
            ]
        });
    }
    var names = getFriendNames(friends);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mr: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageGroup_ImageGroup, {
                    images: friends.map(function(friend) {
                        return {
                            url: friend.avatar,
                            alt: friend.username
                        };
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "caption",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: names.id,
                    values: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, names.values), {
                        b: function(v) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                style: {
                                    color: theme.palette.text.primary
                                },
                                children: v
                            });
                        }
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Friends_Friends = (Friends);

// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 5 modules
var polished_esm = __webpack_require__(78770);
;// CONCATENATED MODULE: ./src/components/@game-detail/GamblingWarning/GamblingWarning.tsx






var GamblingWarning = function() {
    var theme = (0,useTheme/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        bgcolor: (0,polished_esm/* rgba */.m4)(theme.palette.warning.main, 0.08),
        p: 4,
        color: (0,polished_esm/* darken */._j)(0.13, theme.palette.warning.main),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "subtitle1",
                component: "p",
                color: "inherit",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "game.details.gambling_warning.title"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body2",
                color: "inherit",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "game.details.gambling_warning.body"
                })
            })
        ]
    });
};
/* harmony default export */ var GamblingWarning_GamblingWarning = (GamblingWarning);

;// CONCATENATED MODULE: ./src/queries/games/useLeaderboard.ts






var useLeaderboard = function(id) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        enabled: true
    };
    var isLoggedIn = (0,useAuth/* useAuth */.a)().isLoggedIn;
    var ref = (0,es.useQuery)(QueryKeys/* QueryKeys.allgames.leaderboard */.i.allgames.leaderboard(id), function() {
        return ApiService/* default.getGameLeaderboards */.Z.getGameLeaderboards(id);
    }, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
        enabled: isLoggedIn && options.enabled
    })), data = ref.data, isLoading = ref.isLoading;
    return {
        isLoading: isLoading,
        leaderboards: data
    };
};

// EXTERNAL MODULE: ./src/components/@navigation/Link/Link.tsx
var Link = __webpack_require__(18780);
;// CONCATENATED MODULE: ./src/components/@game-detail/Leaderboard/LeaderboardLoading.tsx




var LeaderboardLoading = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        mx: 4,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                width: 200,
                height: 20
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                width: 260,
                height: 16
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                width: 220,
                height: 16
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                height: 56,
                display: "flex",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: 30,
                        height: 20
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mx: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            variant: "circle",
                            width: 40,
                            height: 40
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: "calc(100% - 32px - 40px - 30px)",
                        height: 20
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                height: 56,
                display: "flex",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: 30,
                        height: 20
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mx: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            variant: "circle",
                            width: 40,
                            height: 40
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: "calc(100% - 32px - 40px - 30px)",
                        height: 20
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Leaderboard_LeaderboardLoading = (LeaderboardLoading);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/List/List.js
var List = __webpack_require__(62822);
// EXTERNAL MODULE: ./src/components/@game-detail/Leaderboard/LeaderboardListItem.tsx
var LeaderboardListItem = __webpack_require__(91941);
;// CONCATENATED MODULE: ./src/components/@game-detail/Leaderboard/LeaderboardSection.tsx




var LeaderboardSection = function(param) {
    var players = param.players, title = param.title, body = param.body, currentUser = param.currentUser;
    var youIdx = players.findIndex(function(p) {
        return p.id === currentUser;
    });
    var prevUserId = youIdx > 0 ? players[youIdx - 1].id : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                mx: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h6",
                        component: "h2",
                        color: "textPrimary",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        my: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            color: "textSecondary",
                            children: body
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                disablePadding: true,
                children: players.map(function(param) {
                    var username = param.username, avatar = param.avatar, rank = param.rank, points = param.points, id = param.id;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LeaderboardListItem/* default */.Z, {
                        name: username,
                        score: points,
                        imageUrl: avatar,
                        position: rank,
                        isYou: id === currentUser,
                        divider: id !== prevUserId && id !== currentUser
                    }, username);
                })
            })
        ]
    });
};
/* harmony default export */ var Leaderboard_LeaderboardSection = (LeaderboardSection);

;// CONCATENATED MODULE: ./src/components/@game-detail/Leaderboard/Leaderboard.tsx










var Leaderboard_ref = config_default()(), Leaderboard_config = Leaderboard_ref.publicRuntimeConfig;
var Leaderboard = function(param) {
    var gameId = param.gameId, gameName = param.gameName;
    var isMounted = (0,useMounted/* default */.Z)();
    var ref = (0,useAuth/* useAuth */.a)(), isLoggedIn = ref.isLoggedIn, user = ref.user;
    var intl = (0,useIntl/* default */.Z)();
    var ref1 = useLeaderboard(gameId), leaderboards = ref1.leaderboards, isLoading = ref1.isLoading;
    if (isLoading || !isMounted || !isLoggedIn || !user) {
        if (isMounted && !isLoggedIn && !isLoading) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mx: 4,
                mt: 4,
                textAlign: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "h4",
                    component: "div",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            role: "img",
                            "aria-label": "trophy",
                            children: "\uD83C\uDFC6"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            my: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h6",
                                component: "p",
                                color: "textPrimary",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "game.details.leaderboard.login.title"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            color: "textSecondary",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "game.details.leaderboard.login.body"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            mt: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                component: Link/* default */.C,
                                href: Leaderboard_config.DIGI_LOGIN_URL,
                                variant: "contained",
                                color: "primary",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "game.details.leaderboard.login.button"
                                })
                            })
                        })
                    ]
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Leaderboard_LeaderboardLoading, {});
    }
    var ref2;
    var friends = (ref2 = leaderboards === null || leaderboards === void 0 ? void 0 : leaderboards.friendsLeaderboard) !== null && ref2 !== void 0 ? ref2 : [];
    var ref3;
    var overall = (ref3 = leaderboards === null || leaderboards === void 0 ? void 0 : leaderboards.totalLeaderboard) !== null && ref3 !== void 0 ? ref3 : [];
    var ref4;
    var totalPlayers = (ref4 = leaderboards === null || leaderboards === void 0 ? void 0 : leaderboards.totalPlayers) !== null && ref4 !== void 0 ? ref4 : 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            friends.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: 6,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Leaderboard_LeaderboardSection, {
                    title: intl.formatMessage({
                        id: "game.details.leaderboard.friends.title"
                    }),
                    body: intl.formatMessage({
                        id: "game.details.leaderboard.friends.body"
                    }),
                    players: friends,
                    currentUser: user.id
                })
            }),
            overall.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Leaderboard_LeaderboardSection, {
                title: intl.formatMessage({
                    id: "game.details.leaderboard.overall.title"
                }),
                body: intl.formatMessage({
                    id: "game.details.leaderboard.overall.body"
                }, {
                    game: gameName,
                    total: totalPlayers
                }),
                players: overall,
                currentUser: user.id
            })
        ]
    });
};
/* harmony default export */ var Leaderboard_Leaderboard = (Leaderboard);

// EXTERNAL MODULE: ./src/components/@home/NotLoggedInCta/NotLoggedInCta.tsx
var NotLoggedInCta = __webpack_require__(14357);
// EXTERNAL MODULE: ./src/components/@tabs/TabPanel/TabPanel.tsx
var TabPanel = __webpack_require__(94679);
;// CONCATENATED MODULE: ./src/components/@game-detail/GameDetail/GameDetailButtons.tsx










var GameDetailButtons = function(param) {
    var game = param.game, isLoadingUrl = param.isLoadingUrl, isErrorUrl = param.isErrorUrl, isLoadingSubscriptions = param.isLoadingSubscriptions, isSubscribedTo = param.isSubscribedTo, handlePlayClick = param.handlePlayClick;
    var isMounted = (0,useMounted/* default */.Z)();
    var isLoggedIn = (0,useAuth/* useAuth */.a)().isLoggedIn;
    var intl = (0,useIntl/* default */.Z)();
    if ((0,game_utils/* isExternalGameProvider */.eP)(game.provider)) {
        var providerShortCode = (0,game_utils/* getGameProviderShortcode */.iU)(game.provider);
        if (isLoadingSubscriptions || !isMounted) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                width: "100%",
                height: 42,
                variant: "rect"
            });
        } else if (providerShortCode && isSubscribedTo(providerShortCode)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        component: Link/* default */.C,
                        href: game.url,
                        variant: "contained",
                        color: "primary",
                        fullWidth: true,
                        disabled: !isLoggedIn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "game.details.actions.view"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mt: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            component: Link/* default */.C,
                            href: routes/* Routes.subscriptions */.Z.subscriptions,
                            variant: "outlined",
                            color: "primary",
                            fullWidth: true,
                            disabled: !isLoggedIn,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "game.details.actions.manage_subscription"
                            })
                        })
                    })
                ]
            });
        } else if (providerShortCode) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mb: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            component: Link/* default */.C,
                            href: routes/* Routes.subscriptions */.Z.subscriptions,
                            variant: "contained",
                            color: "primary",
                            fullWidth: true,
                            disabled: !isLoggedIn,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "game.details.actions.play",
                                values: {
                                    amount: game.price.toLowerCase() === "free" ? intl.formatMessage({
                                        id: "game.details.price.free"
                                    }) : game.price
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        width: "100%",
                        textAlign: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            color: "textSecondary",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: // TODO: check all possibilities
                                game.subscriptionType === game_definitions/* SubscriptionType.oneTimePurchase */.Qe.oneTimePurchase ? "game.explainer_text.one_time_pay" : "game.explainer_text.per_game_session"
                            })
                        })
                    })
                ]
            });
        } else {
            return null;
        }
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    my: 2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: handlePlayClick,
                        variant: "contained",
                        color: "primary",
                        fullWidth: true,
                        disabled: !isLoggedIn || isErrorUrl || isLoadingUrl,
                        children: isLoadingUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                            size: 24
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "game.details.actions.play",
                            values: {
                                amount: game.price.toLowerCase() === "free" ? intl.formatMessage({
                                    id: "game.details.price.free"
                                }) : game.price
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    width: "100%",
                    textAlign: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        color: "textSecondary",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: // TODO: check all possibilities
                            game.subscriptionType === game_definitions/* SubscriptionType.oneTimePurchase */.Qe.oneTimePurchase ? "game.explainer_text.one_time_pay" : "game.explainer_text.per_game_session"
                        })
                    })
                })
            ]
        });
    }
};
/* harmony default export */ var GameDetail_GameDetailButtons = (GameDetailButtons);

;// CONCATENATED MODULE: ./src/components/@game-detail/GameDetail/GameDetail.tsx


























var GameDetail = function(param) {
    var game = param.game, collectionId = param.collectionId;
    var intl = (0,useIntl/* default */.Z)();
    var isMounted = (0,useMounted/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var ref = (0,useAuth/* useAuth */.a)(), isLoggedIn = ref.isLoggedIn, user = ref.user;
    var send = (0,useAnalytics/* useAnalytics */.z)().send;
    var ref1 = (0,useSubscriptions/* useSubscriptions */.P)({
        enabled: (0,game_utils/* isExternalGameProvider */.eP)(game.provider)
    }), isSubscribedTo = ref1.isSubscribedTo, isLoadingSubscriptions = ref1.isLoading;
    var ref2 = useFriendsPlaying(game.id), friends = ref2.friends, isLoadingFriends = ref2.isLoading;
    var ref3 = (0,useJumpBackIn/* useJumpBackIn */.C)(), jumpBackIn = ref3.jumpBackIn, isLoadingJumpBackIn = ref3.isLoading;
    var collection = (0,useCollectionById/* useCollectionById */.d)(collectionId).collection;
    var ref4 = (0,react.useState)(), activeTabIndex = ref4[0], setActiveTabIndex = ref4[1];
    var ref5 = (0,react.useState)(false), fetchExternalUrl = ref5[0], setFetchExternalUrl = ref5[1];
    var path = (0,routes_utils/* generatePath */.G)(routes/* Routes.game */.Z.game, {
        slug: game.slugName
    });
    var _webviewRequiresToken;
    var ref6 = (0,useExternalGameUrl/* useExternalGameUrl */.h)(game.id, (_webviewRequiresToken = game.webviewRequiresToken) !== null && _webviewRequiresToken !== void 0 ? _webviewRequiresToken : false, {
        enabled: fetchExternalUrl,
        onSuccess: function(url) {
            if (!!url) router.push(path);
        }
    }), isLoading = ref6.isLoading, isError = ref6.isError;
    var userPlayedTheGame = jumpBackIn ? !!jumpBackIn.find(function(g) {
        return g.id === game.id;
    }) : undefined;
    var loadingTabs = !isMounted || isLoggedIn && isLoadingJumpBackIn;
    var usedTabIndex = activeTabIndex !== null && activeTabIndex !== void 0 ? activeTabIndex : userPlayedTheGame && game.leaderboard ? 0 : 1;
    var handleTabChange = function(_event, newValue) {
        setActiveTabIndex(newValue);
    };
    var handleTabChangeIndex = function(index) {
        setActiveTabIndex(index);
    };
    var handlePlayClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                send({
                    event: events/* Events.gamePlayed */.z.gamePlayed,
                    data: {
                        game: {
                            slug: game === null || game === void 0 ? void 0 : game.slugName
                        }
                    },
                    withUser: true
                });
                if (game.type === game_definitions/* TypeOfGame.webview */.f2.webview) {
                    setFetchExternalUrl(true);
                } else {
                    router.push(path);
                }
                return [
                    2
                ];
            });
        });
        return function handlePlayClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                display: "flex",
                flexDirection: "column",
                mb: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    mx: 4,
                    mb: 2,
                    children: [
                        (0,game_utils/* canPlayGame */.IS)(game) && /*#__PURE__*/ (0,jsx_runtime.jsx)(GameDetail_GameDetailButtons, {
                            isLoadingSubscriptions: isLoadingSubscriptions,
                            isLoadingUrl: isLoading,
                            isSubscribedTo: isSubscribedTo,
                            isErrorUrl: isError,
                            game: game,
                            handlePlayClick: handlePlayClick
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NotLoggedInCta/* default */.ZP, {
                            title: intl.formatMessage({
                                id: "games.login.title"
                            }),
                            description: intl.formatMessage({
                                id: "games.login.body"
                            }),
                            titleVariant: "h6",
                            bgcolor: "background.paper",
                            p: 4,
                            borderRadius: 4,
                            my: 6
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                m: 4,
                children: [
                    isLoggedIn && user && !isLoadingFriends && /*#__PURE__*/ (0,jsx_runtime.jsx)(Friends_Friends, {
                        friends: friends,
                        avatar: user.avatar,
                        shareTitle: game.name
                    }),
                    (!isMounted || isLoadingFriends) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FriendLoading/* default */.Z, {
                        height: 36
                    })
                ]
            }),
            game.isGameOfChance && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                m: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GamblingWarning_GamblingWarning, {})
            }),
            loadingTabs ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* default */.Z, {
                            value: false,
                            onChange: handleTabChange,
                            variant: "fullWidth",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        width: 120,
                                        height: 22
                                    }),
                                    id: "tab-0-loading",
                                    disabled: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        width: 120,
                                        height: 22
                                    }),
                                    id: "tab-1-loading",
                                    disabled: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            my: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Leaderboard_LeaderboardLoading, {})
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    game.leaderboard && /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* default */.Z, {
                            value: usedTabIndex,
                            onChange: handleTabChange,
                            variant: "fullWidth",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "game.details.tabs.leaderboard"
                                    }),
                                    id: "tab-0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "game.details.tabs.about"
                                    }),
                                    id: "tab-1"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        my: 6,
                        children: game.leaderboard ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* default */.ZP, {
                            disableLazyLoading: true,
                            index: usedTabIndex,
                            onChangeIndex: handleTabChangeIndex,
                            // This line is a temporary fix https://github.com/oliviertassinari/react-swipeable-views/issues/599
                            containerStyle: {
                                transition: "transform 0.35s cubic-bezier(0.15, 0.3, 0.25, 1) 0s"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel/* default */.Z, {
                                    value: usedTabIndex,
                                    index: 0,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Leaderboard_Leaderboard, {
                                        gameId: game.id,
                                        gameName: game.name
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel/* default */.Z, {
                                    value: usedTabIndex,
                                    index: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(About_About, {
                                        recommendedGames: collection.slice(0, 3),
                                        details: mapGameDetails(game),
                                        showTitle: !game.leaderboard
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(About_About, {
                            recommendedGames: collection.slice(0, 3),
                            details: mapGameDetails(game),
                            showTitle: !game.leaderboard
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var GameDetail_GameDetail = (GameDetail);

// EXTERNAL MODULE: ./src/queries/subscriptions/useUnsubscribe.ts
var useUnsubscribe = __webpack_require__(25019);
;// CONCATENATED MODULE: ./src/queries/subscriptions/useSubscribe.ts







var useSubscribe = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var intl = (0,useIntl/* default */.Z)();
    var queryClient = (0,es.useQueryClient)();
    var ref = (0,es.useMutation)(function(url) {
        return ApiService/* default.proxySubscriptionEventUrl */.Z.proxySubscriptionEventUrl(url);
    }, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
        onSuccess: function(data) {
            if (data.status === "true") {
                queryClient.invalidateQueries(QueryKeys/* QueryKeys.subscriptions.all */.i.subscriptions.all());
            } else {
                enqueueSnackbar(intl.formatMessage({
                    id: "subscriptions.activate.error"
                }), {
                    variant: "error"
                });
            }
        },
        onError: function() {
            enqueueSnackbar(intl.formatMessage({
                id: "subscriptions.activate.error"
            }), {
                variant: "error"
            });
        }
    })), subscribe = ref.mutate, isLoading = ref.isLoading;
    return {
        subscribe: subscribe,
        isLoading: isLoading
    };
};

// EXTERNAL MODULE: ./src/components/@common/Button/GradientTextButton.tsx
var GradientTextButton = __webpack_require__(95871);
// EXTERNAL MODULE: ./src/components/@common/ConfirmationDialog/ConfirmationDialog.tsx
var ConfirmationDialog = __webpack_require__(44494);
;// CONCATENATED MODULE: ./src/components/@game-detail/SubscriptionDetail/SubscriptionDetail.tsx













var SubscriptionDetail = function(param) {
    var subscription = param.subscription, collectionId = param.collectionId;
    var intl = (0,useIntl/* default */.Z)();
    var isMounted = (0,useMounted/* default */.Z)();
    var ref = (0,react.useState)(), subscribeState = ref[0], setSubscribeState = ref[1];
    var collection = (0,useCollectionById/* useCollectionById */.d)(collectionId).collection;
    var isLoggedIn = (0,useAuth/* useAuth */.a)().isLoggedIn;
    var ref1 = (0,useSubscriptions/* useSubscriptions */.P)(), isSubscribedTo = ref1.isSubscribedTo, subscriptionsIsLoading = ref1.isLoading;
    var ref2 = (0,useUnsubscribe/* useUnsubscribe */.p)(), unsubscribe = ref2.unsubscribe, unsubscribeIsLoading = ref2.isLoading;
    var ref3 = useSubscribe(), subscribe = ref3.subscribe, subscribeIsLoading = ref3.isLoading;
    var handleSubscribe = function() {
        subscribe(subscription.subscribeUrl);
        setSubscribeState(undefined);
    };
    var handleUnsubscribe = function() {
        unsubscribe(subscription.unsubscribeUrl);
        setSubscribeState(undefined);
    };
    var renderButtons = function() {
        if (subscriptionsIsLoading || !isMounted) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                width: "100%",
                height: 42,
                variant: "rect"
            });
        } else if (isSubscribedTo(subscription.shortCode)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: function() {
                            return setSubscribeState("unsubscribe");
                        },
                        variant: "outlined",
                        color: "primary",
                        fullWidth: true,
                        disabled: unsubscribeIsLoading || !isLoggedIn,
                        children: unsubscribeIsLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                            size: 24
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "subscription.details.actions.deactivate"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        textAlign: "center",
                        mt: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            color: "textSecondary",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: // TODO: check all possibilities
                                subscription.subscriptionType === game_definitions/* SubscriptionType.oneTimePurchase */.Qe.oneTimePurchase ? "game.explainer_text.one_time_pay" : "game.explainer_text.per_game_session"
                            })
                        })
                    })
                ]
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: function() {
                            return setSubscribeState("subscribe");
                        },
                        variant: "contained",
                        color: "primary",
                        fullWidth: true,
                        disabled: subscribeIsLoading || !isLoggedIn,
                        children: subscribeIsLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                            size: 24
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "subscription.details.actions.activate",
                            values: {
                                amount: subscription.price.toLowerCase() === "free" ? intl.formatMessage({
                                    id: "game.details.price.free"
                                }) : subscription.price
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        textAlign: "center",
                        mt: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            color: "textSecondary",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: // TODO: check all possibilities
                                subscription.subscriptionType === game_definitions/* SubscriptionType.oneTimePurchase */.Qe.oneTimePurchase ? "game.explainer_text.one_time_pay" : "game.explainer_text.per_game_session"
                            })
                        })
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                flexDirection: "column",
                mb: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        mx: 4,
                        mb: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                mb: 6,
                                children: [
                                    renderButtons(),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NotLoggedInCta/* default */.ZP, {
                                        title: intl.formatMessage({
                                            id: "games.login.title"
                                        }),
                                        description: intl.formatMessage({
                                            id: "games.login.body"
                                        }),
                                        titleVariant: "h6",
                                        bgcolor: "background.paper",
                                        p: 4,
                                        borderRadius: 4,
                                        my: 6
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h6",
                                component: "p",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "game.details.tabs.about"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(About_About, {
                        recommendedGames: collection.slice(0, 3),
                        details: mapGameDetails(subscription)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmationDialog/* default */.Z, {
                isOpen: !!subscribeState,
                title: intl.formatMessage({
                    id: "subscription.details.dialog.".concat(subscribeState !== null && subscribeState !== void 0 ? subscribeState : "subscribe", ".title")
                }),
                description: intl.formatMessage({
                    id: "subscription.details.dialog.".concat(subscribeState !== null && subscribeState !== void 0 ? subscribeState : "subscribe", ".body")
                }, {
                    amount: subscription.price.toLowerCase() === "free" ? intl.formatMessage({
                        id: "game.details.price.free"
                    }) : subscription.price
                }),
                onClose: function() {
                    return setSubscribeState(undefined);
                },
                secondaryButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    color: "primary",
                    onClick: function() {
                        return setSubscribeState(undefined);
                    },
                    disabled: unsubscribeIsLoading,
                    size: "medium",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "general.button.cancel"
                    })
                }),
                primaryButton: subscribeState === "subscribe" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientTextButton/* default */.Z, {
                    disabled: unsubscribeIsLoading || subscribeIsLoading,
                    onClick: handleSubscribe,
                    size: "medium",
                    children: unsubscribeIsLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                        size: 24
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "subscription.details.dialog.".concat(subscribeState !== null && subscribeState !== void 0 ? subscribeState : "subscribe", ".button")
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    color: "secondary",
                    disabled: unsubscribeIsLoading || subscribeIsLoading,
                    onClick: handleUnsubscribe,
                    size: "medium",
                    children: unsubscribeIsLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                        size: 24
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "subscription.details.dialog.".concat(subscribeState !== null && subscribeState !== void 0 ? subscribeState : "subscribe", ".button")
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var SubscriptionDetail_SubscriptionDetail = (SubscriptionDetail);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Favorite.js
var Favorite = __webpack_require__(76324);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/FavoriteBorder.js
var FavoriteBorder = __webpack_require__(28106);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/@game-detail/TitleBar/TitleBar.tsx









var TitleBar = function(param) {
    var title = param.title, iconUrl = param.iconUrl, category = param.category, isFavorited = param.isFavorited, bannerImage = param.bannerImage, onFavoriteClick = param.onFavoriteClick;
    var isLoggedIn = (0,useAuth/* useAuth */.a)().isLoggedIn;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        flexDirection: "column",
        children: [
            bannerImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                width: "100%",
                height: 148,
                position: "relative",
                overflow: "hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: bannerImage,
                    alt: title,
                    layout: "fill",
                    objectFit: "cover",
                    priority: true,
                    blurDataURL: blurBase64/* default */.Z,
                    placeholder: "blur"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                p: 4,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GameIcon/* default */.Z, {
                            src: iconUrl,
                            size: 64,
                            alt: title,
                            imagesAboveFold: true,
                            blurDataURL: blurBase64/* default */.Z
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        ml: 1,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        flexGrow: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h5",
                                component: "h1",
                                color: "textPrimary",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body2",
                                color: "textSecondary",
                                children: category
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        "aria-label": isFavorited ? "unfavorite ".concat(title) : "favorite ".concat(title),
                        onClick: function() {
                            return onFavoriteClick(!isFavorited);
                        },
                        disabled: !isLoggedIn,
                        children: isFavorited ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Favorite/* default */.Z, {
                            color: "secondary"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteBorder/* default */.Z, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TitleBar_TitleBar = (TitleBar);

;// CONCATENATED MODULE: ./src/pages/games/[slug].tsx
















var _slug_useStyles = (0,makeStyles/* default */.Z)({
    offset: {
        marginTop: 56
    },
    playButtonSub: {
        width: "100%",
        textAlign: "center"
    }
});
var GameDetails = function(param) {
    var _slug = param.slug, slug = _slug === void 0 ? "" : _slug, _gameId = param.gameId, gameId = _gameId === void 0 ? "" : _gameId, _collectionId = param.collectionId, collectionId = _collectionId === void 0 ? "" : _collectionId;
    var router = (0,useBackRouter/* useBackRouter */.k)(routes/* Routes.home */.Z.home);
    var game = (0,useGetGameDetails/* useGetGameDetails */.i)(gameId).game;
    var ref = useFavorite(), isFavoritedGame = ref.isFavoritedGame, favoriteGame = ref.favoriteGame, unFavoriteGame = ref.unFavoriteGame;
    var send = (0,useAnalytics/* useAnalytics */.z)().send;
    var path = !!slug.length ? (0,routes_utils/* generatePath */.G)(routes/* Routes.game */.Z.game, {
        slug: slug
    }) : "";
    var intl = (0,useIntl/* default */.Z)();
    var classes = _slug_useStyles();
    (0,react.useEffect)(function() {
        if (!!path.length) {
            router.prefetch(path);
        }
    }, [
        router,
        path
    ]);
    (0,react.useEffect)(function() {
        send({
            event: events/* Events.gameSeen */.z.gameSeen,
            data: {
                game: {
                    slug: game === null || game === void 0 ? void 0 : game.slugName
                }
            },
            withUser: true
        });
    }, [
        send,
        game === null || game === void 0 ? void 0 : game.slugName
    ]);
    if (router.isFallback || !game) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                size: 24
            })
        });
    }
    var handleFavorite = function(isFavorited) {
        if (isFavorited) {
            favoriteGame({
                id: game.id
            });
        } else {
            unFavoriteGame({
                id: game.id
            });
        }
    };
    var isSubscription = game.contentType === game_definitions/* ContentType.subscription */.zc.subscription;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: intl.formatMessage({
                    id: "seo.title.games.slug"
                }, {
                    game: game.name
                }),
                description: game.description,
                openGraph: {
                    images: [
                        {
                            url: game.largeTeaserImage
                        }
                    ]
                },
                additionalMetaTags: [
                    {
                        // Required because we use digi api to unsubscribe which is http
                        httpEquiv: "content-security-policy",
                        content: "upgrade-insecure-requests"
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Background/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailsNavigationBar_DetailsNavigationBar, {
                title: game.name,
                category: game.collection,
                iconUrl: game.smallTeaserImage,
                onBackClick: router.back,
                price: game.price,
                payType: intl.formatMessage({
                    id: game.subscriptionType === game_definitions/* SubscriptionType.oneTimePurchase */.Qe.oneTimePurchase ? "game.explainer_text.one_time_pay" : "game.explainer_text.per_game_session"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.offset
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: "sm",
                disableGutters: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleBar_TitleBar, {
                            title: game.name,
                            category: game.collection,
                            iconUrl: game.smallTeaserImage,
                            isFavorited: isFavoritedGame(game.id),
                            bannerImage: game.largeTeaserImage,
                            onFavoriteClick: handleFavorite
                        }),
                        isSubscription ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionDetail_SubscriptionDetail, {
                            subscription: game,
                            collectionId: collectionId
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(GameDetail_GameDetail, {
                            game: game,
                            collectionId: collectionId
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (GameDetails);


/***/ }),

/***/ 49874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useCollectionById; }
/* harmony export */ });
/* harmony import */ var queries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11777);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88767);
/* harmony import */ var services_api_ApiService__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58416);



var useCollectionById = function(id) {
    var ref, ref1;
    var fetchCollection = function(params) {
        var cursor = undefined;
        if (params.pageParam) cursor = params.pageParam.split("?cursor=")[1];
        return services_api_ApiService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getGameCollection */ .Z.getGameCollection(id, cursor);
    };
    var ref2 = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useInfiniteQuery)(queries__WEBPACK_IMPORTED_MODULE_2__/* .QueryKeys.collectionbyid.all */ .i.collectionbyid.all(id), fetchCollection, {
        enabled: !!id.length,
        getNextPageParam: function(lastPage) {
            return lastPage.loadMoreUrl;
        }
    }), data = ref2.data, isLoading = ref2.isLoading, fetchNextPage = ref2.fetchNextPage, hasNextPage = ref2.hasNextPage, isFetchingNextPage = ref2.isFetchingNextPage;
    return {
        isLoading: isLoading,
        isFetchingNextPage: isFetchingNextPage,
        fetchNextPage: fetchNextPage,
        hasNextPage: hasNextPage !== null && hasNextPage !== void 0 ? hasNextPage : false,
        collection: data ? (ref1 = data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : ref.map(function(page) {
            return page.items;
        })) === null || ref1 === void 0 ? void 0 : ref1.filter(function(i) {
            return i !== undefined;
        }).flat(1) : []
    };
};


/***/ }),

/***/ 85177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useJumpBackIn; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22291);
/* harmony import */ var queries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11777);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88767);
/* harmony import */ var services_api_ApiService__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58416);






var useJumpBackIn = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        enabled: true
    };
    var isLoggedIn = (0,hooks__WEBPACK_IMPORTED_MODULE_1__/* .useAuth */ .a)().isLoggedIn;
    var ref = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(queries__WEBPACK_IMPORTED_MODULE_2__/* .QueryKeys.jumpBackIn.all */ .i.jumpBackIn.all(), function() {
        return services_api_ApiService__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getJumpBackInCollection */ .Z.getJumpBackInCollection();
    }, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
        enabled: isLoggedIn && options.enabled
    })), data = ref.data, isLoading = ref.isLoading, isError = ref.isError, refetch = ref.refetch;
    return {
        isLoading: isLoading,
        isError: isError,
        refetch: refetch,
        jumpBackIn: (isLoggedIn ? data !== null && data !== void 0 ? data : [] : []).filter(function(f) {
            return f !== null;
        })
    };
};


/***/ }),

/***/ 96420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useGetGameDetails; }
/* harmony export */ });
/* harmony import */ var queries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11777);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88767);
/* harmony import */ var services_api_ApiService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58416);



var useGetGameDetails = function(id) {
    var ref = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(queries__WEBPACK_IMPORTED_MODULE_1__/* .QueryKeys.gamedetail.byId */ .i.gamedetail.byId(id), function() {
        return services_api_ApiService__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getGameDetails */ .Z.getGameDetails(id);
    }, {
        enabled: !!id
    }), game = ref.data, isLoading = ref.isLoading;
    return {
        isLoading: isLoading,
        game: game
    };
};


/***/ }),

/***/ 76829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useExternalGameUrl; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8972);
/* harmony import */ var queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11777);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86896);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88767);
/* harmony import */ var services_api_ApiService__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58416);






var useExternalGameUrl = function(id, webviewRequiresToken) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var enqueueSnackbar = (0,notistack__WEBPACK_IMPORTED_MODULE_0__/* .useSnackbar */ .Ds)().enqueueSnackbar;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var ref = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)(queries__WEBPACK_IMPORTED_MODULE_3__/* .QueryKeys.allgames.externalurl */ .i.allgames.externalurl(id), function() {
        return services_api_ApiService__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getExternalGameUrl */ .Z.getExternalGameUrl(id);
    }, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        enabled: !!webviewRequiresToken,
        onError: function() {
            enqueueSnackbar(intl.formatMessage({
                id: "games.error.play"
            }), {
                variant: "error"
            });
        }
    }, options)), data = ref.data, isLoading = ref.isLoading, isError = ref.isError;
    return {
        isError: isError,
        isLoading: isLoading,
        data: data !== null && data !== void 0 ? data : {
            url: ""
        }
    };
};


/***/ }),

/***/ 58147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useSubscriptions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22291);
/* harmony import */ var queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11777);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88767);
/* harmony import */ var services_api_ApiService__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58416);







var useSubscriptions = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        enabled: true
    };
    var isLoggedIn = (0,hooks__WEBPACK_IMPORTED_MODULE_2__/* .useAuth */ .a)().isLoggedIn;
    var ref = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)(queries__WEBPACK_IMPORTED_MODULE_3__/* .QueryKeys.subscriptions.all */ .i.subscriptions.all(), function() {
        return services_api_ApiService__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getSubscriptions */ .Z.getSubscriptions();
    }, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, options), {
        enabled: isLoggedIn && options.enabled
    })), data = ref.data, isLoading = ref.isLoading;
    var isSubscribedTo = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(shortCode) {
        if (data) {
            return !!data.subscriptions.find(function(s) {
                return s.shortCode === shortCode;
            });
        }
    }, [
        data
    ]);
    return {
        isLoading: isLoading,
        isSubscribedTo: isSubscribedTo,
        subscriptions: data
    };
};


/***/ }),

/***/ 25019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useUnsubscribe; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8972);
/* harmony import */ var queries__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11777);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86896);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88767);
/* harmony import */ var services_api_ApiService__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58416);







var useUnsubscribe = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var enqueueSnackbar = (0,notistack__WEBPACK_IMPORTED_MODULE_0__/* .useSnackbar */ .Ds)().enqueueSnackbar;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQueryClient)();
    var ref = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useMutation)(function(url) {
        return services_api_ApiService__WEBPACK_IMPORTED_MODULE_3__/* ["default"].proxySubscriptionEventUrl */ .Z.proxySubscriptionEventUrl(url);
    }, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
        onSuccess: function(data) {
            if (data.status === "true") {
                queryClient.invalidateQueries(queries__WEBPACK_IMPORTED_MODULE_6__/* .QueryKeys.subscriptions.all */ .i.subscriptions.all());
            } else {
                enqueueSnackbar(intl.formatMessage({
                    id: "subscriptions.deactivate.error"
                }), {
                    variant: "error"
                });
            }
        },
        onError: function() {
            enqueueSnackbar(intl.formatMessage({
                id: "subscriptions.deactivate.error"
            }), {
                variant: "error"
            });
        }
    })), unsubscribe = ref.mutate, isLoading = ref.isLoading;
    return {
        unsubscribe: unsubscribe,
        isLoading: isLoading
    };
};


/***/ }),

/***/ 45362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D$": function() { return /* binding */ GameType; },
/* harmony export */   "Qe": function() { return /* binding */ SubscriptionType; },
/* harmony export */   "Ui": function() { return /* binding */ GameProvider; },
/* harmony export */   "f2": function() { return /* binding */ TypeOfGame; },
/* harmony export */   "zc": function() { return /* binding */ ContentType; }
/* harmony export */ });
var GameProvider;
(function(GameProvider) {
    GameProvider["Newcom"] = "Newcom";
    GameProvider["Gameloft"] = "Gameloft";
    GameProvider["Nazara"] = "Nazara";
})(GameProvider || (GameProvider = {}));
var ContentType;
(function(ContentType) {
    ContentType["game"] = "game";
    ContentType["subscription"] = "subscription";
})(ContentType || (ContentType = {}));
var TypeOfGame;
(function(TypeOfGame) {
    TypeOfGame["scratch"] = "scratch";
    TypeOfGame["token"] = "token";
    TypeOfGame["quiz"] = "quiz";
    TypeOfGame["raffle"] = "raffle";
    TypeOfGame["vote"] = "vote";
    TypeOfGame["webview"] = "webview";
    TypeOfGame["slot"] = "slot";
    TypeOfGame["wheel"] = "wheel";
})(TypeOfGame || (TypeOfGame = {}));
var GameType;
(function(GameType) {
    GameType["firstParty"] = "FirstParty";
    GameType["thirdParty"] = "ThirdParty";
    GameType["service"] = "Service";
})(GameType || (GameType = {}));
var SubscriptionType;
(function(SubscriptionType) {
    SubscriptionType["perGameSession"] = "PerGameSession";
    SubscriptionType["oneTimePurchase"] = "OneTimePurchase";
    SubscriptionType["inGamePurchases"] = "InGamePurchases";
    SubscriptionType["perMessage"] = "PerMessage";
})(SubscriptionType || (SubscriptionType = {}));


/***/ }),

/***/ 62698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IS": function() { return /* binding */ canPlayGame; },
/* harmony export */   "eP": function() { return /* binding */ isExternalGameProvider; },
/* harmony export */   "iU": function() { return /* binding */ getGameProviderShortcode; }
/* harmony export */ });
/* harmony import */ var constants_games__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51222);
/* harmony import */ var services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45362);


var canPlayGame = function(param) {
    var type = param.type, url = param.url;
    // Do not show a play button when api decides to leave out the url...
    if (Object.values(services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_0__/* .TypeOfGame */ .f2).includes(type)) {
        return true;
    }
    return Boolean(url);
};
var isExternalGameProvider = function(provider) {
    return provider ? [
        services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_0__/* .GameProvider.Gameloft */ .Ui.Gameloft,
        services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_0__/* .GameProvider.Nazara */ .Ui.Nazara
    ].includes(provider) : false;
};
var getGameProviderShortcode = function(provider) {
    return provider ? constants_games__WEBPACK_IMPORTED_MODULE_1__/* .GAME_PROVIDER_SHORTCODES */ ._[provider] : undefined;
};


/***/ }),

/***/ 24039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ generatePath; }
/* harmony export */ });
/* unused harmony export enhancePathsWithLocales */
/* harmony import */ var path_to_regexp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51068);

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;
function compilePath(path) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    // Keep cache of PathFunctions
    if (cache[path]) return cache[path];
    var generator = (0,path_to_regexp__WEBPACK_IMPORTED_MODULE_0__/* .compile */ .MY)(path, options);
    if (cacheCount < cacheLimit) {
        // populate cache
        cache[path] = generator;
        cacheCount++;
    }
    return generator;
}
/**
 * Generates a valid path you can use for manually pushing to routes.
 * e.g. "/users/:id" > generatePath("/users/:id", { id: 1 }) > "/users/1"
 */ function generatePath() {
    var path = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "/", params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return path === "/" ? path : compilePath(path)(params);
}
function enhancePathsWithLocales(paths, locales) {
    if (!locales) {
        return paths;
    }
    var localePaths = [];
    paths.forEach(function(p) {
        locales.forEach(function(l) {
            localePaths.push({
                params: p.params,
                locale: l
            });
        });
    });
    return localePaths;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9282,9416,7314,273,4242,4615,9774,2888,179], function() { return __webpack_exec__(18544); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);